// Industry-specific landing-page variants used by `/for/:industry` routes.
// The Instagram/Meta paid-ad funnels point each audience to a specific URL
// so the visitor sees copy that mirrors the ad they just clicked.
// Adding a new variant: drop a new entry here, then run the ad against
// `/for/<slug>?utm_source=...`.
export const INDUSTRY_VARIANTS = {
  cafe: {
    label: 'Cafés',
    h1Pre: 'Fill quiet ',
    h1Highlight: 'Tuesdays',
    h1Post: ' with AI ads for your café.',
    sub: 'From the morning flat-white crowd to weekend brunch — describe your café in a sentence and get Meta-ready ads that bring locals through the door.',
    cta: 'Make my first café ad',
    sampleBusiness: 'The Daily Grind Café',
    sampleBrief: 'Tuesday 2-for-1 brunch deal, 10am-2pm, Instagram-friendly poached eggs and homemade focaccia.',
  },
  salon: {
    label: 'Salons & Beauty',
    h1Pre: 'Book out your ',
    h1Highlight: 'empty chairs',
    h1Post: ' with AI Instagram ads.',
    sub: 'Hair, nails, lashes, brows — describe your service in a sentence and get scroll-stopping ads that turn likes into appointments.',
    cta: 'Make my first salon ad',
    sampleBusiness: 'Glow Hair & Beauty',
    sampleBrief: 'Mid-week 20% off balayage with our senior colourist, pre-wedding glow up packages available.',
  },
  tradespeople: {
    label: 'Trades',
    h1Pre: 'More ',
    h1Highlight: 'local jobs',
    h1Post: ', less time chasing leads.',
    sub: 'Plumbers, sparks, builders, gardeners — describe what you do and we generate Meta ads that ring your phone.',
    cta: 'Get my first trade ad',
    sampleBusiness: 'Mike Watson Plumbing & Heating',
    sampleBrief: 'Gas-safe registered, 24/7 emergency call-outs in Lincoln, no call-out fee on weekday repairs.',
  },
  restaurant: {
    label: 'Restaurants',
    h1Pre: 'Pack your ',
    h1Highlight: 'tables',
    h1Post: ', tonight.',
    sub: 'Independent restaurants and takeaways — describe your menu and we generate ads that turn scrollers into bookings and orders.',
    cta: 'Make my first restaurant ad',
    sampleBusiness: 'Nonna Rosa Italian Kitchen',
    sampleBrief: 'Thursday set menu: 3 courses £25 with a glass of house wine, family-run Italian in the city centre.',
  },
  retail: {
    label: 'Retail',
    h1Pre: 'Sell more from your ',
    h1Highlight: 'feed',
    h1Post: '.',
    sub: 'Florists, boutiques, gift shops — describe a product or promo and our AI writes a scroll-stopping ad in 30 seconds.',
    cta: 'Make my first shop ad',
    sampleBusiness: 'Bloom & Petal Florists',
    sampleBrief: 'Valentines Day bouquets from £25, hand-tied with British-grown seasonal blooms, free Lincoln delivery.',
  },
  fitness: {
    label: 'Fitness & Gyms',
    h1Pre: 'New members ',
    h1Highlight: 'every week',
    h1Post: ', without ad agency fees.',
    sub: 'PTs, classes, boutique gyms — describe your offer and we generate ads that get sign-ups and bookings.',
    cta: 'Make my first gym ad',
    sampleBusiness: 'Forge Strength & Conditioning',
    sampleBrief: 'Free 7-day pass for new members, expert coaches, small-group strength classes mornings & evenings.',
  },
};

export function getIndustryVariant(slug) {
  if (!slug) return null;
  return INDUSTRY_VARIANTS[slug.toLowerCase()] || null;
}
